import React from 'react';

import img1 from '../assests/img/partner-3.jpg';
import img2 from '../assests/img/partner-4.jpg';
import img3 from '../assests/img/partner-5.jpg';
import img4 from '../assests/img/partner-6.jpg';
import img5 from '../assests/img/partner-7.jpg';
import img6 from '../assests/img/partner-8.jpg';
import img7 from '../assests/img/partner-9.jpg';





function Liveupdate() {
  return (
    <>

      <section className="show-activity partner-sec">

        <div className='sec-title'>
          <h2>Why Choose Aadikaash International for Showcasing Your Silver Jewellery</h2>
          <div class="separator"></div>
        </div>

        <div className='container'>
          <div className='row'>

            <div className='col-md-12 quick-update-heading'>
              {/* <h2>Celebrating 5th edition of India Silver Jewellery Show-ISJS & All India Jewellery Expo-AIJE India’s Largest Silver Jewellery B2B Show.</h2> */}
              <ul>
                <li><span>Proven Expertise</span> Over 10 years of experience in organizing India’s leading B2B jewellery exhibitions.</li>
                <li><span>Industry Trust</span> Recognized by ISJS & AIJE for excellence and professionalism.</li>
                <li><span>Targeted Exposure</span> Connect directly with premium buyers, retailers, and distributors.</li>
                <li><span>Commitment to Growth</span> Promoting compliance, standardization, and sustainable industry practices.</li>
                <li><span>Global Visibility</span> A perfect stage to highlight your brand among top silver jewellery businesses.  </li>
              </ul>             
            </div>
            <div className='col-md-12 mt-4 text-center'>
               <p>Aadikaash International ensures that every exhibitor experiences the highest level of professionalism, organization, and opportunity.</p>
            </div>


            <div className='col-md-4 hide'>
              <div className='update-box'>
                <div className='sec-title'>
                  <h2>Quick Updates</h2>
                  <div class="separator"></div>
                </div>
                <ul class="inner_under_listing">
                  <li><a href="#" target="_blank">ISJS Premiere 2025 Exhibitor List - Coming Soon   </a></li>
                  <li><a href="#" target="_blank" class="d-block"> ISJS 2025 Floorplan  </a></li>
                  {/* <li><a href="#" target="_blank" class="d-block">  ASJS Premiere 2025 Exhibitor List</a></li> */}
                  <li><a href="#" target="_blank" class="d-block">  ISJS 2025 Visitor Registration </a></li>



                </ul>
              </div>
            </div>


          </div>
        </div>
      </section>

    </>
  )

}

export default Liveupdate;
